export default __webpack_public_path__ + "static/media/Hero Image.1e2ffaa6.png";